<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span>
        <mat-chip-set aria-label="Entity count">
          <mat-chip class="title-chip">{{ resourceCount }}</mat-chip>
        </mat-chip-set>
      </span>
      <span>{{ 'scheduler.visitType-detail.skillProfile.title' | translate }}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="grid-toolbar">
    <button mat-flat-button color="primary" (click)="addResource()">
      <mat-icon>add</mat-icon>
      {{ 'scheduler.general.add' | translate }}
    </button>
    <span class="spacer"></span>
    <button mat-flat-button (click)="discardChanges()" [disabled]="pristine" color="warn">
      {{ 'scheduler.general.discardChanges' | translate }}
    </button>
    <button mat-flat-button (click)="saveChanges()" [disabled]="pristine" color="accent">
      {{ 'scheduler.general.saveChanges' | translate }}
    </button>
  </div>

  <div class="grid-container">
    <app-grid
      [columns]="columns"
      [store]="gridStore"
      [filter]="false"
      [showContextMenu]="true"
      [showDirty]="true"
      [showRemoveRowInContextMenu]="true"
      [width]="'100%'"
      (gridEvents)="onGridEvent($event)">
    </app-grid>
  </div>
</mat-expansion-panel>
